/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useElementEvents from '@core/hooks/cohesion/useElementEvents';
import {
  addProgramToCompareList,
  removeProgramFromCompareList,
  setIsComparisonBannerOpen,
  selectProgramsToCompare,
} from '@core/reducers/matchesSlice';
import type { VoyagerResult } from '@core/ts/results';

import styles from './CompareCheckbox.module.css';

const CompareCheckbox = ({ result }: { result: VoyagerResult }) => {
  const programsToCompare = useSelector(selectProgramsToCompare);
  const [isChecked, setIsChecked] = useState(false);
  const dispatch = useDispatch();

  const { elementClicked } = useElementEvents({
    webElement: {
      elementType: 'compare-feature',
      text: result?.school?.name,
      location: 'compare-voyager',
      htmlId: 'checkbox',
      name: 'compare-checkbox',
    },
    actionOutcome: !isChecked ? 'checked' : 'unchecked',
  });
  const handleOnChange = () => {
    elementClicked();
    if (!isChecked) {
      dispatch(addProgramToCompareList(result));
    } else {
      dispatch(removeProgramFromCompareList(result));
    }
    dispatch(setIsComparisonBannerOpen(true));
  };

  useEffect(() => {
    setIsChecked(programsToCompare.some((p) => p?.program?.id === result?.program?.id));
  }, [programsToCompare, result]);

  return (
    <label className={styles.checkbox} onClick={(e) => e.stopPropagation()} htmlFor={result?.program?.id.toString()}>
      <input
        checked={isChecked}
        disabled={programsToCompare.length === 3 && !isChecked}
        onChange={handleOnChange}
        type="checkbox"
        id={result?.program?.id.toString()}
      />
      <span>Compare</span>
    </label>
  );
};

export default CompareCheckbox;
